import IconSecurityCheck from "assets/svg/icon-security-check";
import { Button } from "components/commons";
import Loading from "components/loading";
import Td from "components/Td";
import { useGetLoanQuery } from "generated/graphql";
import { useNavigation } from "hooks";
import { ISimulationResult } from "interfaces/interfaces";
import { useEffect, useState } from "react";
import { formatMoney, getLoanApplicationParams } from "utils/utils";
import { recalculateSimulationResult } from 'utils/simulation-utils';
import '../../assets/scss/partner-summary.scss';

const PartnerSummary: React.FC = () => {
    const {
        goToBizcapitalSite,
        goToPartnerAntiFraudIdentification
    } = useNavigation();
    const [simulation, setSimulation] = useState({} as ISimulationResult);
    const loanApplicationId  = getLoanApplicationParams();

    const { data, loading } = useGetLoanQuery({
        variables:{
            id: loanApplicationId
        },
        fetchPolicy:"network-only"
    });

    const acceptedProposal = data?.loanApplication?.acceptedProposal;
    const partnerPaysFees = data?.loanApplication?.product?.mdcSettings?.partnerPaysFees;
    const discounts = [];

    useEffect(() => {
        if(!acceptedProposal?.interestRate || !acceptedProposal?.tenure) {
            return null;
        }
        setSimulation(recalculateSimulationResult(
            data.loanApplication,
            discounts,
            data.loanApplication.product.bizId
        ));
    }, [acceptedProposal])

    return (
        loading ?
            <Loading /> : (
        <div className="container-partner-summary">
            <h2>confira os dados do seu financiamento</h2>
            <div className="highlight-card card">
                <div className="pt-4 px-4">
                    <h3 className="mb-4 mt-3">
                        Seu financiamento
                    </h3>
                    <table className="table table-borderless table-sm">
                        <tbody>
                            <tr>
                                <td>
                                    Valor total do bem
                                </td>
                                <Td value={data?.loanApplication?.amountRequested} />
                            </tr>
                            <tr>
                                <td>
                                    Valor da entrada
                                </td>
                                <Td value={data?.loanApplication?.acceptedProposal?.downPaymentAmount} />
                            </tr>
                            <tr className="total-line font-weight-bolder">
                                <td>
                                    Valor total financiado
                                </td>
                                <Td value={data?.loanApplication?.amountRequested - data?.loanApplication?.acceptedProposal?.downPaymentAmount} />
                            </tr>
                        </tbody>
                    </table>
                </div>

            <div className="grid-summary-footer-partner">
                <div>
                    <h4>
                        Pagamento em <span className="font-weight-bold">{ data?.loanApplication?.acceptedProposal?.tenure } parcelas de</span>
                    </h4>

                    <h2 className="partner-color-primary">
                        R$ {formatMoney(simulation.pmt)}
                    </h2>
                </div>

                <p>
                    O Custo Efetivo Total (CET) é de { partnerPaysFees ? 0 : (simulation?.cet?.monthlyRate * 100).toFixed(2) ?? ''}%
                    ao mês ou {partnerPaysFees ? 0 : (simulation?.cet?.annualyRate * 100).toFixed(2) ?? ''}%
                    ao ano e já está incluído no valor total a pagar
                </p>

            </div>
            </div>
            <div className='container-message-continue'>
                <IconSecurityCheck className="icon-security-check" />
                <div>
                    <p className="partner-font-bold partner-color-primary">deseja continuar?</p>
                    <p className="partner-color-secondary">
                        caso os dados do financiamento estejam de acordo com o que você <br className="br-mobile" />
                        espera, basta prosseguir.
                    </p>
                </div>
            </div>
            <footer>
                <Button
                    label="agora não"
                    variant="partner-secondary"
                    className="button"
                    onClick={goToBizcapitalSite}
                />
                <Button
                    label="continuar"
                    variant="partner-primary"
                    className="button"
                    onClick={goToPartnerAntiFraudIdentification}
                />
            </footer>
        </div>
        )
    )
}

export default PartnerSummary;
